import { BronzeConsistencyIncentiveSection } from '@sections/BronzeConsistencyIncentiveSection'
import { BronzeIncentivesSection } from '@sections/BronzeIncentivesSection'
import { BusinessSection } from '@sections/BusinessSection'
import { DepthSection } from '@sections/DepthSection'
import { FrontlineGrowthIncentiveSection } from '@sections/FrontlineGrowthIncentiveSection'
import { FrontlinesSection } from '@sections/FrontlinesSection'
import { PerformanceIncentivesSection } from '@sections/PerformanceIncentivesSection'
import { PersonalGroupGrowthSection } from '@sections/PersonalGroupGrowthSection'
import { SectionComponentClass } from '@sections/SectionComponent'
import { TwoTimeCashIncentiveSection } from '@sections/TwoTimeCashIncentiveSection'

export function simulatorPageSection2024(): SectionComponentClass[] {
  const sections = [
    BusinessSection,
    FrontlinesSection,
    DepthSection,
    BronzeIncentivesSection,
    BronzeConsistencyIncentiveSection,
    PerformanceIncentivesSection,
    PersonalGroupGrowthSection,
    FrontlineGrowthIncentiveSection,
    TwoTimeCashIncentiveSection
  ]

  return sections
}
